import { useMemo } from 'react';
import * as React from 'react';

import { BetType } from '@/lib/apollo/types/gen/graphql';
import { getOddsRange } from '@/lib/race';
import { Odds } from '@/modelTypes';

import { Span } from './style';

const OddsRange: React.FC<{
  odds: Odds | null;
  setNums: number[];
  betType: BetType;
}> = ({ odds, setNums, betType }) => {
  const oddsRange = useMemo(() => {
    if (odds) {
      return getOddsRange(odds, setNums, betType);
    }
    return null;
  }, [odds, setNums, betType]);

  if (!oddsRange) {
    return <>-</>;
  }

  if (betType === BetType.QuinellaPlace || setNums.length > 1) {
    return (
      <span>
        {oddsRange.min.toFixed(1)}
        <Span>~</Span>
        {oddsRange.max.toFixed(1)}
      </span>
    );
  }
  return <>{oddsRange.max.toFixed(1)}</>;
};

export default OddsRange;
